import React, { useState } from "react";
import { Link } from "react-router-dom";
import SRList from "../component/List";
import AkkhorLayout from "../layout/akkhor";
import SearchBoxModal from "../component/SearchBoxModal";

export default function DanhSachLoaiHopDong() {
  // `params` là chuỗi query đã áp dụng (gửi lên API), các state còn lại là giá trị đang gõ.
  // Tách ra để gõ xong bấm "Lọc" mới gọi API, không gọi lại mỗi lần nhấn phím.
  const [params, setParams] = useState('');
  const [title, setTitle] = useState('');
  const [authorCode, setAuthorCode] = useState('');
  const [filterShow, setFilterShow] = useState(false);
  // SearchBoxModal chỉ xoá nhãn đang hiển thị khi resetKey đổi, đặt lại state là chưa đủ.
  const [resetKey, setResetKey] = useState(0);

  // Tiền tố f_ để không đụng bộ lọc tự động theo tên cột trong all.php (filterparam).
  const handleSubmit = (e) => {
    e.preventDefault();
    let _param = '';
    if (title) _param += "&f_title=" + encodeURIComponent(title);
    if (authorCode) _param += "&f_author_code=" + encodeURIComponent(authorCode);
    setParams(_param);
  };

  const handleReset = () => {
    setTitle('');
    setAuthorCode('');
    setParams('');
    setResetKey((k) => k + 1);
  };

  let columns = [
    { name: "id", label: "ID" },
    { name: "title", label: "Tiêu đề" },
    { name: "filetype", label: "Loại file" },
    {
      name: "author_code",
      label: "Người tạo",
      options: {
        // Backend (more/hopdong_type.php) join users theo author_code để trả về
        // tên, phòng ban, chức vụ. Nếu nhân sự đã bị xoá thì chỉ còn mã.
        customBodyRender: (value, row) => (
          <div>
            <div>{row.author_name || value || ''}</div>
            {(row.author_chucvu || row.author_part) &&
              <small className="text-muted d-block">
                {[row.author_chucvu, row.author_part].filter((i) => i).join(' - ')}
              </small>
            }
            {row.author_name && value && <small className="text-muted d-block">{value}</small>}
          </div>
        ),
      },
    },
  ];

  return (<AkkhorLayout idrole="dashboard">
    <div className="breadcrumbs-area">
        <ul>
            <li>
              <Link to="/">Trang chủ</Link>
            </li>
            <li>
              Danh sách mẫu hợp đồng
            </li>
        </ul>
    </div>

    <div className="card card-filter mb-3">
      <div className="card-header">
        <div className="d-flex" onClick={() => setFilterShow(!filterShow)}>
          <div className="mr-auto">
            <h3 className="title">Tìm kiếm</h3>
          </div>
          <button className="btn btn-sm btn-defaul"><span className={!filterShow ? "fas fa-angle-down" : "fas fa-angle-up"}></span></button>
        </div>
      </div>
      <div className={filterShow ? "card-body" : 'hidden-filter'}>
        <form className="new-added-form" method="get" onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-lg-4 col-md-6 col-12 form-group">
              <label>Tiêu đề</label>
              <input type="text" placeholder="Tên mẫu hợp đồng" value={title} onChange={(e) => setTitle(e.target.value)} className="form-control height32" autoComplete="off" />
            </div>
            <div className="col-lg-4 col-md-6 col-12 form-group">
              <label>Người tạo</label>
              <SearchBoxModal apiname={"users"} placeholder="Chọn người tạo" colvalue={'code'} colname={'fullname'} name='author_code' defaultValue={authorCode} resetKey={resetKey}
                onChange={(e) => setAuthorCode(e)}></SearchBoxModal>
            </div>
            <div className="col-12">
              <button type="submit" className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark">Lọc</button>
              <button type="button" onClick={handleReset} className="btn btn-sm btn-secondary ml-2">Bỏ lọc</button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <SRList name="hopdong_type" linkaction="mau-hop-dong" idrole="mau-hop-dong" params={params} title="" defaultLimit={50} serverSide={true} columns={columns} >
    </SRList>
  </AkkhorLayout>);
}
